export default "__VITE_ASSET__BDWwJJJk__"